import { configureStore } from "@reduxjs/toolkit";
import Auth from "./slice/auth";
import Users from "./slice/users";
import Roles from "./slice/roles";
import Common from "./slice/common";
import FormElements from "./slice/formElements";
import Associates from "./slice/associates";
import Screens from "./slice/screens";
import Pincodes from "./slice/pincodes";
import ServiceCategories from "./slice/serviceCategories";
import Pricing from "./slice/pricing";
import Fixers from "./slice/fixers";

// RTK's configureStore automatically includes redux-thunk middleware
// and wires up Redux DevTools Extension — no extra packages needed.
export default function setupStore(preloadedState = {}) {
  return configureStore({
    reducer: {
      auth: Auth,
      users: Users,
      roles: Roles,
      associates: Associates,
      screens: Screens,
      pincodes: Pincodes,
      serviceCategories: ServiceCategories,
      pricing: Pricing,
      fixers: Fixers,
      common: Common,
      formElements: FormElements,
    },
    preloadedState,
  });
}
